import { ValueOf } from 'type-fest';

import { Status } from 'lib/generated/proto/roboverse_platform_protos/statekeeping/Reported/Status';

import { PayloadDTO } from './Payload';
import { RobotTemplateDTO } from './RobotAction';

/**
 * Iothub device name is the unique identifier of the robot in the Azure IoT Hub.
 */
export type DeviceName = string;

export enum SystemType {
  LINUX = 'Linux',
  WINDOWS = 'Windows',
}

export const ROBOT_MODEL = {
  SPOT: 'spot',
  MAGNI: 'magni',
  TURTLEBOT: 'turtlebot',
  DRONE: 'matrice_4td',
  ANYMAL: 'anymal',
  GENERIC_QUADROCOPTER: 'generic_quadcopter',
  GENERIC_ROVER: 'generic_rover',
  RB_WATCHER: 'rb_watcher',
  SMARTPHONE: 'smartphone',
} as const;

export type ROBOT_MODEL = ValueOf<typeof ROBOT_MODEL>;

export enum OperatingStatus {
  IDLE = 'IDLE', // connected and ready to do something
  TELEOPERATION = 'TELEOPERATION', // someone is actively controlling this robot through teleoperation
  ON_MISSION = 'ON_MISSION', // the robot is carrying out an autonomous routine
  EXTERNAL_USE = 'EXTERNAL_USE', // the robot is carrying out an autonomous routine
}

export type MyRobotsPrimaryInformationResponse = {
  myRobotId: number;
  deviceName: string;
  modelName: string; // enum on the backend so it's safe to use it as the type of the robot
  thumbnailURL: string;
  status?: Status;
  connectionState: ConnectionState;
};

/**
 * Extended version for the frontend having the image URL
 */
export type MyRobotsPrimaryInformationResponseDTO = MyRobotsPrimaryInformationResponse & {
  imageUrl: string;
  modelName: ROBOT_MODEL; // it was validated at this point
};

export type ConnectionState = {
  state: string; // Connected | Disconnected
  lastUpdatedTime: string;
};

export type NetworkStatus = {
  latency: string;
  arePortsOpen: string;
  downloadSPeed: string;
  lastUpdateTime: string;
  fullStateBlobKey: string;
};

type MyRobotToPayloadDTO = {
  myRobotToPayloadId: number;
  isActive: boolean;
  devicePath: string;
  myRobotId: number;
  // todo - that will cause a loop and currently now sure if payload wil be send here anyway
  // MyRobot: MyRobotDTO;
  payloadId: number;
  payload: PayloadDTO;
};

export type MyRobotDTO = {
  myRobotId: number;
  systemType: SystemType;
  serialNumber: string;
  defaultLiveStreamChannel: string;
  iotHubDeviceName: string;
  companyDomain: string;
  robotTemplateId: number;
  robotTemplate: RobotTemplateDTO;
  myRobotToPayloads: MyRobotToPayloadDTO[];
};
